import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { User } from "./User";
import UserQueryNode, {
  type UserQuery$variables,
} from "./__generated__/UserQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof User> = {
  root: JSResource("User", () =>
    import("./User").then((module) => module.User),
  ),
  getPreloadProps({ params }) {
    const variables: UserQuery$variables = {
      username: params.id!,
    };

    return {
      queries: {
        query: {
          parameters: UserQueryNode,
          variables,
        },
      },
    };
  },
};

export default entryPoint;
